import './SelectableItem.scss';

import React, {useCallback} from 'react';

import Icon from '../icons/Icon';

const SRC_CHECKED = '/img/checkmark.png';
// const SRC_UNCHECKED = '/img/unchecked_checkbox.png';

const SeletableItem = props => {
    const {className, checked, color, selectedStyle, onChange, children} = props,
        classes = ['SelectableItem', className, checked ? 'checked' : 'unchecked'],
        style = {
            color: props.color,
            ...props.style,
            ...(checked ? props.selectedStyle : {}),
        };

    let mark;
    if (style.color) {
        if (checked) {
            mark = (
                <Icon className="mark" src={SRC_CHECKED} color={style.color} noIconClass style={{borderColor: style.color, backgroundColor: 'transparent'}} />
            );
        } else {
            mark = <div className="mark" style={{borderColor: style.color, backgroundColor: 'transparent'}} />;
        }
    } else {
        mark = <div className="mark" />;
    }

    const handleToggleState = useCallback(() => {
        onChange(!checked);
    }, [checked, onChange]);

    return (
        <div className={classes.join(' ')} style={style} onClick={handleToggleState}>
            {mark}
            {children}
        </div>
    );
};

export default SeletableItem;
